import { render, staticRenderFns } from "./highPay.vue?vue&type=template&id=2c4df16c&scoped=true&"
import script from "./highPay.vue?vue&type=script&lang=js&"
export * from "./highPay.vue?vue&type=script&lang=js&"
import style0 from "./highPay.vue?vue&type=style&index=0&id=2c4df16c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4df16c",
  null
  
)

export default component.exports